/**
 * QueueManagerPage - Queue primitive management (Admin View)
 *
 * LIFE-CRITICAL: Queue management ensures timely processing of
 * workflows, especially time-sensitive healthcare and financial operations.
 *
 * Surfaces the QueueManager component for admin/architect users.
 *
 * Route: /admin/queues
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconList } from '@tabler/icons-react';

import { QueueManager } from '@/components/admin/QueueManager';
import { useAuth } from '@/auth/AuthContext';

export function QueueManagerPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="violet">
            <IconList size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Queue Management</Title>
            <Text size="sm" c="dimmed">
              Task queues, dead letter queues, saga coordination, and scheduled jobs
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <QueueManager />
    </Container>
  );
}
